import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { IStorePackage } from 'models/store/i-store-package.interface';

import { ROUTES } from 'constants/routes.constant';

import Button from 'components/buttons/Button';
import { PackageImage } from 'components/packageImage/PackageImage';

import { ScreenSize, useScreenSize } from 'hooks/useScreenSize';

import { formatRmvPrice } from 'utils/parser.utils';
import { getBaseVariationPrice } from 'utils/trade-variations.utils';

import { NftPackageParamRow } from './NftPackageParamRow';

type NftPackageProps = {
  packageData: IStorePackage;
  hideButtons?: boolean;
  hideName?: boolean;
  className?: string;
  displayPrice?: boolean;
  onClickBuy?: (packageData: IStorePackage) => void;
  packageImageCountClassName?: string;
  packageImageCountSubtitleClassName?: string;
};

export const NftPackage = ({
  packageData,
  hideButtons,
  hideName,
  className,
  onClickBuy,
  displayPrice = false,
  packageImageCountClassName,
  packageImageCountSubtitleClassName,
}: NftPackageProps) => {
  const isDesktop = useScreenSize() > ScreenSize.medium;
  const packageUrl = `${ROUTES.PACKAGE}/${packageData.id}`;
  const price = getBaseVariationPrice(packageData.available_trade_offers_by_variation);
  const hasPrice = price !== null;

  return (
    <div
      className={twMerge(
        'tw-x-6 tw-w-full tw-max-w-none tw-rounded-2xl tw-bg-[#0E2659] tw-px-[12px] tw-py-[10px] lg:tw-max-w-[375px] lg:tw-px-[24px] lg:tw-py-[16px]',
        className
      )}
    >
      <Link to={packageUrl} className="tw-block">
        <PackageImage
          src={packageData.image_url}
          alt={packageData.name}
          totalShares={packageData.total_shares}
          className="tw-mx-auto tw-mb-4 tw-block tw-h-auto tw-w-full tw-max-w-full"
          countClassName={packageImageCountClassName}
          countSubtitleClassName={packageImageCountSubtitleClassName}
        />
      </Link>
      {!hideName && (
        <Link to={packageUrl}>
          <h2 className="tw-line-clamp-1 tw-text-center tw-text-[13px] tw-text-white lg:tw-text-[26px]">
            {packageData.name}
          </h2>
        </Link>
      )}
      {displayPrice && (
        <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-1 tw-text-left">
          {/* TEMPORARY disabled until API is updated */}
          {/* <NftPackageParamRow label="Estimated Annual Yield" value={`${packageData.estimated_annual_yield}%`} /> */}
          {/* <NftPackageParamRow label="# of Digital Asset in package" value={packageData.total_items.toString()} /> */}
          {hasPrice && <NftPackageParamRow label="Price per package" value={formatRmvPrice(price)} withIcon />}
        </div>
      )}
      {!hideButtons && (
        <div className="tw-mt-4 tw-flex tw-flex-row tw-gap-2 lg:tw-gap-4">
          <Button
            text="More info"
            size={isDesktop ? 'medium' : 'small'}
            className="tw-min-w-0 tw-flex-1 tw-text-[12px] lg:tw-w-full lg:tw-text-base"
            color="white-outline"
            asLink={true}
            link={`/package/${packageData.id}`}
            target="_self"
          />
          {/* <Button
            text={isSoldOut ? 'Sold out' : 'Buy now'}
            size={isDesktop ? 'medium' : 'small'}
            className="tw-min-w-0 tw-flex-1 tw-text-[12px] lg:tw-w-full lg:tw-text-base"
            disabled={isSoldOut}
            onClick={() => onClickBuy?.(packageData)}
            requireWeb3
          /> */}
        </div>
      )}
    </div>
  );
};
